import axios, {AxiosResponse} from 'axios';

const axiosApiInstance = axios.create();
const baseURL = process.env.REACT_APP_API_ENV === "local" ? "http://localhost:8885" : "https://api-business.trustelev8.com";

axiosApiInstance.defaults.baseURL = baseURL;
axiosApiInstance.interceptors.request.use(
    (config: any) => {
        config.headers = {
            'Authorization': `Bearer ${localStorage.getItem("token")}`,
        }
        return config;
    },
    (error: any) => {
        return Promise.reject(error);
    },
);
// Response interceptor for API calls
axiosApiInstance.interceptors.response.use((response) => {
    return response
}, async function (error) {
    const originalRequest = error.config;
    if (error.response.status === 401 || error.response.status === 403) {
        localStorage.removeItem("token")
        window.location.href = "/login";
        return axiosApiInstance(originalRequest);
    }
    return Promise.reject(error);
});

export interface LoginRequest {
    username: string
    password: string
}
export function postLogin(data: LoginRequest) {
    return fetch(baseURL + "/api/auth", {method: "POST", body: JSON.stringify(data)})
}

export function getConsentStats(): Promise<AxiosResponse<any>> {
    return axiosApiInstance.get("/api/stats/consent")
}

export function getAgeStats(): Promise<AxiosResponse<any>> {
    return axiosApiInstance.get("/api/stats/age")
}

export function getGeoStats(): Promise<AxiosResponse<any>> {
    return axiosApiInstance.get("/api/stats/geo")
}

export interface Consent {
    uid: string
    request_time: Date
}

export function getConsents(start: any, end: any): Promise<AxiosResponse<Array<Consent>>> {
    return axiosApiInstance.get("/api/consents", {params:{start, end}})
}

export function getCustomer(): Promise<AxiosResponse<any>> {
    return axiosApiInstance.get("/api/customer")
}

